module.exports = __webpack_public_path__ + "static/media/reactCertificate.a7bbea30.jpg";